// extracted by mini-css-extract-plugin
module.exports = {"info-block-alert":"marketing-disclaimer_info-block-alert__GytRT","disclaimer":"marketing-disclaimer_disclaimer__rg13a"};